import React, { useState } from 'react';

export function LoginForm({ onLogin, error, isLoading }) {
  const [homeserver, setHomeserver] = useState('https://r3ich.com');

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onLogin(homeserver);
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h1>LiveKit Observer</h1>
        <p>Sign in with your Matrix account to observe encrypted calls</p>

        {error && (
          <div className="error-message">{error}</div>
        )}

        <div className="form-group">
          <label htmlFor="homeserver">Homeserver</label>
          <input
            id="homeserver"
            type="url"
            value={homeserver}
            onChange={(e) => setHomeserver(e.target.value)}
            placeholder="https://matrix.example.com"
            required
            disabled={isLoading}
          />
        </div>

        <button
          type="submit"
          className="btn btn-primary"
          disabled={isLoading}
        >
          {isLoading ? 'Redirecting...' : 'Sign In with Matrix'}
        </button>

        <p className="login-help">
          You will be redirected to your homeserver's authentication page.
        </p>
      </form>
    </div>
  );
}
